import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '0 20px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: `0 ${spacing.medium} 0 40px`,
        },
        [theme.breakpoints.up('md')]: {
            margin: '0 auto',
            padding: 0,
        },
    },
    chooseDate: {
        border: '0 !important',
    },
    submitButton: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            margin: `${spacing.medium} auto 0  auto`,
            maxWidth: '100%',
            justifyContent: 'center',
            borderTop: 'none',
            width: '480px',
        },
    },
    phase2Button: {
        '& button': {
            height: spacing.xl,
        },
    },
    divider: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            width: '80%',
            margin: '0 82px',
            borderBottom: `1px solid ${colors.grey.grey3}`,
        },
        [theme.breakpoints.up('lg')]: {
            margin: '0 136px',
        },
    },
    stepContainer: {
        minWidth: '335px',
        [theme.breakpoints.up('md')]: {
            width: '80%',
            margin: '0 82px',
            padding: 0,
        },
        [theme.breakpoints.up('lg')]: {
            width: '80%',
            margin: '0 136px',
        },
        '&>:first-child': {
            marginTop: 0,
            [theme.breakpoints.up('md')]: {
                marginTop: spacing.medium,
            },
        },
    },
    hideSteps: {
        display: 'none',
    },
    removePadding: {
        [theme.breakpoints.down('xs')]: {
            padding: '0 !important', //overriding the modal styles are
        },
    },
    addPadding: {
        [theme.breakpoints.down('xs')]: {
            padding: '0 20px',
        },
    },
    manualAddressModalContainer: {
        [theme.breakpoints.down('xs')]: {
            overflowY: 'auto',
        },
    },
    stepSelect: {
        borderBottom: `1px solid ${colors.grey.grey3}`,
        margin: `${spacing.medium} 0`,
    },
    noBorderBottom: {
        borderBottom: 'none !important',
        marginBottom: spacing.small,
    },
}));
export default useStyles;
